import React from "react";
import {inject, observer} from "mobx-react";
import Header from "./containers/Header";

import "./assets/stylesheets/App.scss";

@inject('AuthStore', 'Navigator')
@observer
class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pageLoaded: {},
            logged: false
        };
    }

    handleLogout() {
        this.props.AuthStore.doLogout();
        this.props.Navigator.push('/login');
    }

    handleSearch(e) {
        this.props.Navigator.replace(`/search/${e.searchedTerm}`);
    }

    render() {
        return (
            <div className="full-wrapper">
                <Header onSearch={this.handleSearch.bind(this)} onLogout={this.handleLogout.bind(this)}/>
                <div className="App">
                    {React.cloneElement(this.props.children, {key: this.props.location.pathname})}
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js